import { z } from 'zod';
import { IdSchema, DateTimeSchema } from '../../common';
export const GenerateSelfTestSchema = z.object({
    /** Optional narrow; topics may span multiple enrolled subjects. */
    subjectId: IdSchema.optional(),
    /** Optional unit filter hint — topics must still be listed in topicIds. */
    unitId: IdSchema.optional(),
    topicIds: z.array(IdSchema).min(1).max(3),
    difficulty: z.coerce.number().int().min(1).max(5),
    questionCount: z.coerce.number().int().min(1).max(12),
});
export const GenerateSelfTestResultSchema = z.object({
    examId: IdSchema,
});
export const ErrorNotebookSourceTypeSchema = z.enum(['exam_attempt', 'homework', 'self_test']);
export const ErrorNotebookEntrySchema = z.object({
    id: IdSchema,
    questionId: IdSchema,
    sourceType: ErrorNotebookSourceTypeSchema,
    sourceId: IdSchema.nullable(),
    resolvedAt: DateTimeSchema.nullable(),
    createdAt: DateTimeSchema,
    imageUrl: z.string().nullable(),
    text: z.string(),
    gradeLevel: z.number().int().nullable(),
    subjectName: z.string().nullable(),
    unitName: z.string().nullable(),
    topicName: z.string().nullable(),
    solutionVideoUrl: z.string().nullable(),
});
//# sourceMappingURL=self-test.js.map